<template>
  <div class="timezone-table">
    <aside>
      <ul>
        <li v-for="day in days" :key="day">
          <span>{{ day }}</span>
        </li>
      </ul>
    </aside>
    <section>
      <div>
        <header>
          <ul class="timezone-table-header-time">
            <li v-for="(_, i) in 25" :key="i">
              <span
                :style="
                  `color: rgb(75, 85, 99); font-size: 16px; ${
                    i === 0
                      ? 'transform: translateX(0)'
                      : 'transform: translateX(-50%)'
                  }`
                "
                >{{ i }}</span
              >
            </li>
          </ul>
        </header>
        <div class="timezone-table-content-container">
          <ul class="timezone-table-content-line">
            <li
              v-for="(_, i) in 8"
              :key="i"
              :style="i % 2 ? 'background-color: rgb(243, 244, 246);' : ''"
            >
              <span v-for="(_, i) in 49" :key="i" />
            </li>
          </ul>
          <ul class="timezone-table-content-body">
            <li
              v-for="timezone in timezoneDetail"
              :key="timezone.timezone_detail_uuid"
            >
              <div
                v-for="(time, i) in timezone.timezone_time_period"
                :key="i"
                class="tooltip"
              >
                <!-- <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-if="time"
                      class="timezone-table-content-body-item"
                      :style="`left: ${time.start}px; width: ${time.end}px;`"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <span v-if="time">
                    {{ time.time_period_start }} -
                    {{ time.time_period_end }}
                  </span>
                </v-tooltip> -->
                <!-- <span
                  v-if="time"
                  class="timezone-table-content-body-item"
                  :style="`left: ${time.start}px; width: ${time.end}px;`"
                /> -->
                <div
                  v-if="time"
                  class="timezone-table-content-body-item"
                  :style="`left: ${time.start}px; width: ${time.end}px;`"
                >
                  <span v-if="time" class="tooltip-text">
                    {{ time.time_period_start }} -
                    {{ time.time_period_end }}
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    timezoneDetail: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      days: [
        'อาทิตย์',
        'จันทร์',
        'อังคาร',
        'พุธ',
        'พฤหัส',
        'ศุกร์',
        'เสาร์',
        'วันหยุด'
      ]
    }
  }
}
</script>

<style lang="css" scoped>
.timezone-table {
  display: flex;
}

.timezone-table ul {
  list-style-type: none;
  padding: 0;
}

.timezone-table aside {
  margin-top: 32px;
  margin-right: 4px;
}
.timezone-table aside ul {
  width: 100px;
}
.timezone-table aside li {
  color: #111827;
  font-size: 16px;
  background-color: rgb(243, 244, 246);
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.timezone-table section {
  display: flex;
  overflow-x: auto;
}
.timezone-table-header-time {
  display: flex;
  align-items: center;
}
.timezone-table-header-time li {
  height: 32px;
  width: 44px;
  display: flex;
  align-items: center;
}

.timezone-table-content-container {
  position: relative;
  /* width: calc(100% - 48px);
  overflow: hidden; */
}

.timezone-table-content-line {
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  border-right: 1px solid #e5e7eb;
}

.timezone-table-content-line li {
  display: flex;
  height: 40px;
  margin-bottom: 2px;
}
.timezone-table-content-line li:last-child {
  margin-bottom: 0;
}
.timezone-table-content-line span {
  width: 22px;
  border-left: 1px solid rgb(229, 231, 235);
}

.timezone-table-content-body {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.timezone-table-content-body li {
  display: flex;
  height: 40px;
  margin-bottom: 2px;
  position: relative;
}
.timezone-table-content-body-item {
  position: absolute;
  top: 1px;
  bottom: -1px;
  background-color: rgba(21, 128, 61, 0.7);
}

.tooltip {
  position: relative;
  cursor: pointer;
}
.tooltip .tooltip-text {
  position: absolute;
  background-color: #424242;
  color: white;
  padding: 3px 10px;
  border-radius: 5px;
  z-index: 100;
  min-width: 105px;
  visibility: hidden;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
}
</style>
